import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './cartItemsList.css';
import { Link } from 'react-router-dom';
import ProductImageGallery, { getProductImageUrls, ProductImage } from '../../shop/ProductImageGallery';

const formatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 0,
});

const CartItemsList = ({ setIsValid }) => {
  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart);

  useEffect(() => {
    if (cart && cart.items && cart.items.length > 0) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [cart, setIsValid]);

  if (!cart || !cart.items || cart.items.length === 0) {
    return (
      <div className="text-center my-5">
        <div className="alert alert-info">El carrito está vacío</div>
        <Link to="/tienda" className="btn btn-primary mt-3">
          Ir a la tienda y elige qué comprar!
        </Link>
      </div>
    );
  }

  const total = cart.items.reduce(
    (acc, item) => acc + (parseFloat(item.priceCOP) || 0) * item.quantity,
    0
  );

  const rows = cart.items.map(item => {
    const imageUrls = getProductImageUrls(item.imageUrl)
      .filter((url) => typeof url === 'string' && url.trim());

    const price = parseFloat(item.priceCOP) || 0;
    const subtotal = price * item.quantity;

    return (
      <tr key={item.id} className="align-middle">
        <td className="table-image-cell">
          <div className="image-wrapper">
            {imageUrls.length > 1 ? (
              <ProductImageGallery
                imageUrl={item.imageUrl}
                productName={item.name}
                showFullscreenButton={false}
                showPlayButton={false}
                showThumbnails={false}
                additionalClass="compact-carousel"
              />
            ) : (
              <ProductImage
                imageUrl={item.imageUrl}
                alt={item.name}
                className="img-thumbnail"
                style={{
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover',
                }}
              />
            )}

            {/* Marca debajo */}
            {/* Marca debajo */}
            {item.brand && (
              <div className="brand-label d-flex align-items-center gap-2 mt-2">
                {item.brand.logoUrl && (
                  <img
                    src={item.brand.logoUrl}
                    alt={item.brand.name}
                    className="brand-logo"
                  />
                )}
                {/* <small className="brand-name text-muted">{item.brand.name}</small> */}
              </div>
            )}

          </div>
        </td>

        <td>
          <div className="item-name">{item.name}</div>
          <small className="text-muted">{item.category}</small>
        </td>
        <td className="subcat-cell text-center">{item.subcategory || '-'}</td>
        <td className="weight-cell text-center">
          {item.weight ? `${item.weight} lb` : '-'}
        </td>
        <td className="stock-cell text-center">
          {item.stock === 0 ? (
            <span className="fw-bold fst-italic text-danger">
              Lo conseguimos rápido 🔄
            </span>
          ) : (
            <span className="fw-bold text-success">{item.stock}</span>
          )}
        </td>
        <td className="text-center">
          <select
            className="form-select form-select-sm w-auto"
            value={item.quantity}
            onChange={e =>
              dispatch({
                type: 'cart/updateQuantity',
                payload: { id: item.id, quantity: +e.target.value },
              })
            }
          >
            {[...Array(10).keys()].map(i => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
        </td>

        <td className="unit-price-cell text-end">
          {formatter.format(price)}
        </td>
        <td className="subtotal-cell text-end">
          {formatter.format(subtotal)}
        </td>
      </tr>
    );
  });

  return (
    <div className="container my-4">
      <div className="card cart-card shadow-sm">
        <div className="card-header bg-white">
          <h3 className="mb-0 text-primary display-6">
            <i className="bi bi-basket3 me-2"></i>
            Revisa tu pedido
          </h3>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover table-borderless align-middle cart-table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Producto</th>
                  <th scope="col">Subcategoría</th>
                  <th scope="col">Peso</th>
                  <th scope="col">Stock</th>
                  <th scope="col">Cantidad</th>
                  <th scope="col" className="text-end">
                    Precio unit.
                  </th>
                  <th scope="col" className="text-end">
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody>{rows}</tbody>
              <tfoot>
                <tr>
                  <td colSpan="6" className="text-end fw-bold">
                    Total:
                  </td>
                  <td
                    colSpan="2"
                    className="total-cell fw-bold text-end"
                  >
                    {formatter.format(total)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemsList;
